import { formaters } from "vincent-utils";
export default function (rdv1, rdv2) {
    const start = formaters.getHourMinutesFromMinutes(rdvHourInMinutes(rdv1) + rdv1.duration);
    const end = formaters.getHourMinutesFromMinutes(rdvHourInMinutes(rdv2));
    if (!start || !end) {
        throw new Error("start or end is undefined in findEmptyPlageBetweenTwoRdvs");
    }
    return {
        start,
        end,
    };
}
const rdvHourInMinutes = (rdv) => rdv.hour * 60 + rdv.minute;
//# sourceMappingURL=findEmptyPlageBetweenTwoRdvs.js.map